import {lazy, Suspense} from 'react'
import {Routes, Route, useNavigate} from 'react-router-dom'
import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  flex: 1;
  align-self: stretch;
`

const Board = styled.div`
  display: flex;
  flex: 1;
`

const Index = () => {
  const List = lazy(() => import('./List'))
  const Detail = lazy(() => import('./Detail'))
  const Reject = lazy(() => import('./Reject'))
  const Admin = lazy(() => import('./Admin'))
  const Regis = lazy(() => import('./Regis'))

  return (
    <Container>
      <Board>
        <Suspense fallback={''}>
          <Routes>
            {['/', '/:pageNum'].map((path, index) => (
              <Route
                key={index}
                path={path}
                element={<List/>}
              />
            ))}
            {['/detail/:id'].map((path, index) => (
              <Route
                key={index}
                path={path}
                element={<Detail/>}
              />
            ))}
            {['/reject/', '/reject/:pageNum'].map((path, index) => (
              <Route
                key={index}
                path={path}
                element={<Reject/>}
              />
            ))}
            {['/admin/', '/admin/:pageNum'].map((path, index) => (
              <Route
                key={index}
                path={path}
                element={<Admin/>}
              />
            ))}
            {['/admin/regis', '/admin/regis/:id'].map((path, index) => (
              <Route
                key={index}
                path={path}
                element={<Regis/>}
              />
            ))}
          </Routes>
        </Suspense>
      </Board>
    </Container>
  )
}

export default Index
